import React, { useCallback } from 'react';
import { Switch } from 'antd';

import './customSwitch.scss';

export const CustomSwitch = ({ isActive = false, onChange = () => {}, label }) => {
  const onChangeSwitch = useCallback(
    (checked) => {
      onChange(checked);
    },
    [onChange],
  );

  const normalizeIsActive = useCallback(() => {
    if (isActive === 0) {
      return false;
    }
    if (isActive === 1) {
      return true;
    }

    return isActive;
  }, [isActive]);

  return (
    <div className="custom-switch">
      <Switch
        checked={normalizeIsActive()}
        className={normalizeIsActive() ? 'custom-switch--checked' : 'custom-switch--unchecked'}
        onChange={onChangeSwitch}
      />
      {label}
    </div>
  );
};
